// extracted by mini-css-extract-plugin
export default {"editShipping":"cd-z"};